import {
  Button,
  CircularProgress,
  CircularProgressLabel,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useCallback, useEffect, useRef, useState } from "react";
import VideoLoadingAnimation from "./VideoLoadingAmimation";

function LiveImage(props) {
  const videoRef = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!props?.openModal?.open) return;

    setTimeout(async () => {
      await navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: false,
        })
        .then((stream) => {
          videoRef.current.srcObject = stream;
          setLoading(false);

          document
            .getElementById("take-photo")
            .addEventListener("click", async () => {
              let canvas = document.querySelector("#canvas");

              canvas
                .getContext("2d")
                .drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
              canvas.toBlob(async (blob) => {
                let file = new File([blob], "user_image.jpg", {
                  type: "image/jpeg",
                });
                console.log('modalFile: ', file);

                // close the video and send image file

                stream?.getTracks().forEach((track) => {
                  track.stop();
                });
                videoRef.current.srcObject = null;

                props?.onFinish(file);
              }, "image/jpeg");
            });

          document
            .getElementById("cancel")
            .addEventListener("click", async () => {
              stream?.getTracks().forEach((track) => {
                track.stop();
              });
              videoRef.current.srcObject = null;
              props.close();
            });
        });
    }, 3000);
  }, []);

  return (
    <Stack
      position={"relative"}
      justifyContent="center"
      alignItems={"center"}
      py="20px"
      spacing={"20px"}
    >
      {loading && <VideoLoadingAnimation />}
      <video
        ref={videoRef}
        id="video"
        width="520"
        height="340"
        autoPlay
      ></video>
      <Stack direction={"row"} mt="20px">
        <Button
          disabled={loading}
          id="take-photo"
          p="20px"
          size={"xs"}
          bg="#07900C"
          color="#fff"
          _hover={{ background: "#07900C" }}
        >
          Take Photo
        </Button>
        <Button
          disabled={loading}
          id={"cancel"}
          p="20px"
          size={"xs"}
          border="1px solid #80808030"
          bg="transparent"
          _hover={{ background: "transparent" }}
        >
          Cancel
        </Button>
      </Stack>
      <canvas
        id="canvas"
        width="320"
        height="240"
        style={{ display: "none" }}
      ></canvas>
    </Stack>
  );
}

export default LiveImage;
